import { getMyOcBasePath } from '@cx-web/utils';

import { type Repub } from '@cx-modules/constants';

export * from './constants';
export * from './isRedirect';
export * from './types';
export * from './utils';

export function logout(repub: Repub, redirectUrl: string): void {
  const options = {
    method: 'POST',
    headers: {
      'OC-Repub': repub,
      'Content-Type': 'application/json',
    },
    credentials: 'include' as RequestCredentials,
  };

  // The logout endpoint moved from RR7 atlas (`/api/cx/myoc/v2/logout`) to the repub-prefixed
  // myoddschecker namespace (`/{repub}/myoddschecker/logout`) in NGF-6477.
  fetch(`${getMyOcBasePath(repub)}/logout`, options).finally(() => {
    window.location.href = redirectUrl;
  });
}
